import React from 'react';
import { useRecoilState } from 'recoil';
import { gameState, replayState, restartState } from '../state';
import { useSetRecoilState } from 'recoil';
import styled from 'styled-components';
// import { FacebookShare } from './common/facebook';

const StyledScoreBar = styled.div`
color: #f8f9c5;
font-size: 36px;
background-color:#C1671D;
border-radius: 20px;
box-shadow: 0 10px #a25019;
max-height:60px;
max-width: 200px;
padding: 5px 30px 15px 30px;
margin:5px 10px;
@media only screen and (max-width: 600px) {
  font-size: 24px;
  padding: 5px 20px 5px 20px;
  line-height: 150%;
}
`
const StyledResultInfo = styled.div`
display: -webkit-flex;
display:flex;
-webkit-flex-direction: column;
flex-direction: column;
-webkit-align-items: flex-end;
align-items: flex-end; 
margin-top: -100px;
@media only screen and (max-width: 600px) {
margin-top: -120px;
}
`

const StyledShareButton = styled.div`
z-index:10;
display: flex;
margin: 20px 10px;
@media only screen and (max-width: 600px) {
  max-width:30%;
margin: 5px 10px;
}
`
const ShareButton = styled.img`
max-height: 50px;
padding:3px;
@media only screen and (max-width: 600px) {
  max-width:92%;
}
`
const FacebookShare = ({ href, quote, pic }) => {
  const shareLink = `https://www.facebook.com/share.php?u=${href}&quote=${encodeURI(quote)}`
  const share = () => {
    window.open(shareLink, "Popup", "location,status,scrollbars,resizable,width=560,height=400");
  };
  return (
    <img src="img/02share.png" onClick={share} />
  );
};

const FbShareContent = (scores) => {
  const scoreMessge ="你得到了" + scores + "分！\n";
  if (scores <15){
    return scoreMessge + "石虎沒有吃飽，又累又餓QAQ";
  } else if (scores <30){
    return scoreMessge + "石虎還不太會覓食，繼續加油!";
  } else{
    return scoreMessge + "在你的眼明手快下，石虎吃飽飽!";
  } 
};

const FbShareContentPic = (scores) => {
  if (scores <15){
    return "http://user161306.psee.io/3z6dyn/";
  } else if (scores <30){
    return "http://user161306.psee.io/3z33kw/";
  } else{
    return "http://user161306.psee.io/3uktqx/";
  } 
};


const Result = () => {
  const [game, setGameState] = useRecoilState(gameState);
  const setReplay = useSetRecoilState(replayState);
  const setRestart = useSetRecoilState(restartState);

  return (
    <div>
      <div className="start-frame">
        <div className="start-title">
          <StyledResultInfo>
            <StyledScoreBar>
              <b>分數&emsp;{game.score.size < 100 ? "0" : ""}{game.score.size < 10 ? "0" : ""}{game.score.size}</b>
            </StyledScoreBar>
            <StyledShareButton>
            <a href="https://www.facebook.com/2016homeruntaiwan" target="_blank"><ShareButton src={'img/share_fb.png'} /></a>
            <a href="https://www.instagram.com/homerun.taiwan/" target="_blank"><ShareButton src={'img/share_ig.png'} /></a>
          </StyledShareButton>
          </StyledResultInfo>
          <div className="result-board">
            <div className="result-bg-area">
            <div className="result-bg">
              {game.score.size < 15 ? <img src="img/Leopard-cat-result-bg3.png" />
              : game.score.size < 30 ? <img src="img/Leopard-cat-result-bg1.png" /> 
              :<img src="img/Leopard-cat-result-bg2.png" /> } 
            </div>
            <div className="result-bg-mobile">
            {game.score.size < 15 ? <img src="img/Leopard-cat-result-bg-mobile3.png" />
              : game.score.size < 30 ? <img src="img/Leopard-cat-result-bg-mobile1.png" /> 
              :<img src="img/Leopard-cat-result-bg-mobile2.png" /> }
            </div>
            <div className="reslut-detail">
              <p><b>石虎，曾廣泛分布於臺灣淺山森林地區，如今卻僅剩不到 700 隻。近幾年，每年石虎路殺甚至高達3、40隻。</b>
              </p>
              <p>
                Q：石虎住哪裡?<br />
                海拔1,500公尺以下草地、農墾地等淺山闊葉林環境。苗栗、臺中、南投等中部縣市為目前石虎的活動熱區。<br />
              </p>
              <p>
                Q：石虎面臨哪些生存威脅？<br />
                石虎棲地與人類活動範圍高度重疊，環境改變直接影響石虎生存，如環境開發、土地濫墾造成的棲地破碎化，為了覓食不得不穿越馬路，可能遭車輛撞擊；或是誤採捕獸鋏地雷、被流浪犬貓攻擊等，都讓石虎的生存大大不易。<br />
              </p>
              <p>
                Q：日前有哪些保育石虎的方法？<br />
                目標是希望能與「虎」共生。<br />
                了解石虎習性，盡量保存現有棲地，給予牠們足夠的生存空間，也將山林留給石虎；絕不棄養貓犬，不讓流浪動物與野生動物競爭。<br />
                在已開發道路，透過警示牌等方式提醒民眾減速慢行，或設立動物通道等友善道路設施。<br />
              </p>
              <p>
                Q：我能為石虎做什麼？<br />
                分享這個遊戲給你的親朋好友，讓更多人知道石虎的生存危機；你也可以選擇購買友善環境耕作、善待野生動物的農產品，用錢錢來幫助石虎，甚至出力幫石虎搭雞舍！以及，不棄養動物、行經石虎出沒道路時減速慢行、檢舉違法獸鋏，或是發現有受傷、死亡石虎時<a href="https://ahutw.info/report.php" target="_blank">即時通報相關單位</a>。這些行為都可以大大保護石虎唷！<br />
              </p>
            </div>
            
            </div>
            <div className="game-icons">
              <img src="img/01restart.png" onClick={() => setReplay()} />
              <FacebookShare
        href={FbShareContentPic(game.score.size)}
        quote={FbShareContent(game.score.size)}
      />
              <img src="img/03home.png" onClick={() => setRestart()} />
              <img src="img/04exit.png" onClick={() => window.close()}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export {
  Result
};
